import React from "react";
import { keyframes } from "@emotion/core";
import PropTypes from "prop-types";
import styled from "theme/libs/styled";

const SpinWrapper = styled("div")`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Dash = keyframes`
  0% { stroke-dashoffset: 187; }
  50% {
    stroke-dashoffset: 10;
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: 187;
    transform: rotate(450deg);
  }
`;

const Rotator = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(270deg); }
`;

const Spinner = styled("svg")`
    animation: ${Rotator} 1.2s linear infinite;
`;

const Circle = styled("circle")`
    stroke-dasharray: 187;
    stroke-dashoffset: 60;
    transform-origin: center;
    animation: ${Dash} 1.2s ease-in-out infinite;
`;

const Loading = ({ color, width, height, ...props }) => {
    return (
        <SpinWrapper {...props}>
            <Spinner width={width} height={height} viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <Circle stroke={color} fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30" />
            </Spinner>
        </SpinWrapper>
    );
};

Loading.propTypes = {
    color: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

Loading.defaultProps = {
    color: "currentColor",
    height: "40px",
    width: "40px",
};

export default Loading;
